const acceptationEnvironment = ['localhost', 'acc'].some(val => window.location.origin.includes(val))
const stagingEnvironment = ['staging'].some(val => window.location.origin.includes(val))

const endpoints = {
    backendEndpoint: 'https://dashboard.tracefy.net/api',
    liveUpdatesEndpoint: 'https://live.tracefy.net'
}

if (acceptationEnvironment) {
    endpoints.backendEndpoint = 'https://dashboardacc.tracefy.net/api'
    endpoints.liveUpdatesEndpoint = 'https://liveacc.tracefy.net'
} else if (stagingEnvironment) {
    endpoints.backendEndpoint = 'https://dashboardstaging.tracefy.net/api'
    endpoints.liveUpdatesEndpoint = 'https://livestaging.tracefy.net'
}

export { endpoints, acceptationEnvironment }
